import { Injectable } from '@angular/core';

@Injectable()
export class Global {
  attachmentsURL: string = 'https://basf.sharepoint.com/sites/rail-cars-dwell-report/Shared%20Documents/Forms/AllItems.aspx?RootFolder=%2Fsites%2Frail%2Dcars%2Ddwell%2Dreport%2FShared%20Documents%2FMiscellaneous%2FSPECS%2C%20drawings%2C%20gauge%20tables%2C%20and%20MSDS%2FGeneral%20Drawings&FolderCTID=0x01200073FABD9E2E0A664DAB61F6F202514C78';
  
}